
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5077|5982|6689|6826)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
